document.addEventListener("DOMContentLoaded", function () {
    //Lang switcher
    $("#switcher").click(function () {
        $(this).toggleClass("active");
        $("#switcher ul").toggleClass("open");
    });

    let menuShown = false;
    $("#nav-burger").click(function (e) {
        if (!menuShown) {
            menuShown = true;
            $(".main-nav").slideDown("fast", function () {
                $(".alt-nav").slideDown();
            });
        } else {
            menuShown = false;
            $(".main-nav").slideDown("fast", function () {
                $(".alt-nav").slideDown();
            });
        }
    });

    //Slick slider
    $(document).ready(function () {
        if ($(".carousel-header .slide").length > 1) {
            $(".carousel-header").slick({
                autoplay: true,
                autoplaySpeed: 5000,
                draggable: false,
                adaptiveHeight: true,
            });
        }
    });

    // Box colapsable

    var el = document.getElementsByClassName("dyn");
    for (var i = 0; i < el.length; i++) {
        el[i].on = false;
        el[i].onclick = function () {
            if (this.on === false) {
                this.getElementsByClassName("colapsable-content")[0].style.display = "block";
                this.getElementsByClassName("arrow")[0].classList.add("rotated");
                this.on = true;
            } else {
                this.getElementsByClassName("colapsable-content")[0].style.display = "none";
                this.getElementsByClassName("arrow")[0].classList.remove("rotated");
                this.on = false;
            }
        };
    }

    //Handle centering of promos

    var promos = $(".promos-cards .card");
    if (promos.length < 4) {
        $(".promos-cards .cards").css("justify-content", "space-around");
    }

    // Toggle email/phone

    $(".garage-phone").click(function () {
        $(".label-phone").css("display", "none");
        $(".hidden-phone").css("display", "block");
    });
    $(".garage-mail").click(function () {
        $(".label-mail").css("display", "none");
        $(".hidden-mail").css("display", "block");
    });

    // Competition

    const competitionFileLabel = document.querySelector(".competition-form--file label");
    const competitionFileInput = document.querySelector(".competition-form--file input");

    if (competitionFileInput){
        competitionFileInput.addEventListener('change', (e)=>{
            console.log(e)
            let selectedFile = e.target.files[0].name;
            competitionFileLabel.innerText = selectedFile;
        })
    }

    // Cookies footer link
    $(".click_cookies a").click(function () {
        $(this).attr("href", "javascript:Didomi.preferences.show()");
    });
});
